import { __decorate, __param, __metadata } from 'tslib';
import { InjectionToken, Inject, Injectable, Component, Input, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgbActiveModal, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { interval, Subject } from 'rxjs';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc2 from '@angular/common';
const ConfigToken = new InjectionToken('config');

let SessionTimerService = class SessionTimerService {
    constructor(config) {
        this.config = config;
        this.timer = interval(1000);
        this._remainSeconds = new Subject();
        /**
         * Observable to get session remaining time (in seconds).
         *
         * Subscribers need to unsubscribe to it before hosting element is destroyed.
         *
         * @memberof SessionTimerService
         */
        this.remainSeconds$ = this._remainSeconds.asObservable();
        this._timeoutSeconds = config.totalMinutes * 60;
    }
    startTimer() {
        this.stopTimer();
        this._count = this._timeoutSeconds;
        this.timerSubscription = this.timer.subscribe(n => {
            if (this._count > 0) {
                this._count--;
                this._remainSeconds.next(this._count);
            }
        });
    }
    stopTimer() {
        if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
        }
    }
    resetTimer() {
        this.startTimer();
    }
};
SessionTimerService.ɵfac = function SessionTimerService_Factory(t) { return new (t || SessionTimerService)(ɵngcc0.ɵɵinject(ConfigToken)); };
SessionTimerService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: SessionTimerService, factory: SessionTimerService.ɵfac });
SessionTimerService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [ConfigToken,] }] }
];
SessionTimerService = __decorate([ __param(0, Inject(ConfigToken)),
    __metadata("design:paramtypes", [Object])
], SessionTimerService);

let SessionTimerHttpInterceptor = class SessionTimerHttpInterceptor {
    constructor(timerService) {
        this.timerService = timerService;
    }
    intercept(request, next) {
        this.timerService.resetTimer();
        return next.handle(request);
    }
};
SessionTimerHttpInterceptor.ɵfac = function SessionTimerHttpInterceptor_Factory(t) { return new (t || SessionTimerHttpInterceptor)(ɵngcc0.ɵɵinject(SessionTimerService)); };
SessionTimerHttpInterceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: SessionTimerHttpInterceptor, factory: SessionTimerHttpInterceptor.ɵfac });
SessionTimerHttpInterceptor.ctorParameters = () => [
    { type: SessionTimerService }
];
SessionTimerHttpInterceptor = __decorate([ __metadata("design:paramtypes", [SessionTimerService])
], SessionTimerHttpInterceptor);

let SessionInteruptService = class SessionInteruptService {
    constructor() { }
    /**
     * Method to refresh session cookie. Normally, this method issue a quick API call to server.
     *
     * @memberof SessionInteruptService
     */
    continueSession() {
        console.log('You clicked continue session.');
    }
    /**
     * Method to remove session cookie. Normally, this method redirect to website log out end point.
     *
     * @memberof SessionInteruptService
     */
    stopSession() {
        console.log('You clicked stop session.');
    }
};
SessionInteruptService.ɵfac = function SessionInteruptService_Factory(t) { return new (t || SessionInteruptService)(); };
SessionInteruptService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: SessionInteruptService, factory: SessionInteruptService.ɵfac });
SessionInteruptService = __decorate([ __metadata("design:paramtypes", [])
], SessionInteruptService);

let SessionExpirationAlertModalComponent = class SessionExpirationAlertModalComponent {
    constructor(activeModal, sessionInterupter, sessionTimer) {
        this.activeModal = activeModal;
        this.sessionInterupter = sessionInterupter;
        this.sessionTimer = sessionTimer;
    }
    ngOnInit() { }
    continue() {
        this.sessionInterupter.continueSession();
        this.sessionTimer.resetTimer();
        this.activeModal.close();
    }
    logout() {
        this.sessionTimer.stopTimer();
        this.activeModal.close();
        this.sessionInterupter.stopSession();
    }
};
SessionExpirationAlertModalComponent.ɵfac = function SessionExpirationAlertModalComponent_Factory(t) { return new (t || SessionExpirationAlertModalComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgbActiveModal), ɵngcc0.ɵɵdirectiveInject(SessionInteruptService), ɵngcc0.ɵɵdirectiveInject(SessionTimerService)); };
SessionExpirationAlertModalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SessionExpirationAlertModalComponent, selectors: [["ng-component"]], decls: 13, vars: 3, consts: [[1, "modal-header", "bg-warning"], [1, "modal-title"], [1, "modal-body"], [1, "my-4", 2, "font-size", "1.25rem"], [1, "modal-footer"], ["type", "button", 1, "btn", "btn-secondary", 3, "click"], ["type", "button", "ngbAutofocus", "", 1, "btn", "btn-primary", 3, "click"]], template: function SessionExpirationAlertModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "h4", 1);
        ɵngcc0.ɵɵtext(2, "Session is about to expire");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "p");
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵpipe(7, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 4);
        ɵngcc0.ɵɵelementStart(9, "button", 5);
        ɵngcc0.ɵɵlistener("click", function SessionExpirationAlertModalComponent_Template_button_click_9_listener() { return ctx.logout(); });
        ɵngcc0.ɵɵtext(10, " Logout ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "button", 6);
        ɵngcc0.ɵɵlistener("click", function SessionExpirationAlertModalComponent_Template_button_click_11_listener() { return ctx.continue(); });
        ɵngcc0.ɵɵtext(12, " Continue Session ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate1(" Your session will expire in ", ɵngcc0.ɵɵpipeBind1(7, 1, ctx.sessionTimer.remainSeconds$), " seconds. ");
    } }, pipes: [ɵngcc2.AsyncPipe], encapsulation: 2 });
SessionExpirationAlertModalComponent.ctorParameters = () => [
    { type: NgbActiveModal },
    { type: SessionInteruptService },
    { type: SessionTimerService }
];
SessionExpirationAlertModalComponent = __decorate([ __metadata("design:paramtypes", [NgbActiveModal,
        SessionInteruptService,
        SessionTimerService])
], SessionExpirationAlertModalComponent);

let SessionExpirationAlertComponent = class SessionExpirationAlertComponent {
    constructor(sessionTimer, modalService, sessionInterupter) {
        this.sessionTimer = sessionTimer;
        this.modalService = modalService;
        this.sessionInterupter = sessionInterupter;
        this.startTimer = true;
        this.alertAt = 60;
    }
    ngOnInit() {
        if (!this.sessionTimerSubscription && this.startTimer) {
            this.trackSessionTime();
        }
    }
    ngOnChanges(changes) {
        if (changes.startTimer) {
            this.cleanUp();
            if (changes.startTimer.currentValue) {
                this.trackSessionTime();
            }
        }
    }
    trackSessionTime() {
        this.sessionTimer.startTimer();
        this.sessionTimerSubscription = this.sessionTimer.remainSeconds$.subscribe(t => {
            if (t === this.alertAt) {
                this.modalRef = this.modalService.open(SessionExpirationAlertModalComponent, {
                    backdrop: 'static',
                    keyboard: false
                });
            }
            if (t === 0) {
                if (this.modalRef) {
                    this.modalRef.close();
                }
                this.cleanUp();
                this.sessionInterupter.stopSession();
            }
        });
    }
    cleanUp() {
        this.sessionTimer.stopTimer();
        if (this.sessionTimerSubscription) {
            this.sessionTimerSubscription.unsubscribe();
        }
    }
    ngOnDestroy() {
        this.cleanUp();
    }
};
SessionExpirationAlertComponent.ɵfac = function SessionExpirationAlertComponent_Factory(t) { return new (t || SessionExpirationAlertComponent)(ɵngcc0.ɵɵdirectiveInject(SessionTimerService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgbModal), ɵngcc0.ɵɵdirectiveInject(SessionInteruptService)); };
SessionExpirationAlertComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SessionExpirationAlertComponent, selectors: [["session-expiration-alert"]], inputs: { startTimer: "startTimer", alertAt: "alertAt" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 0, vars: 0, template: function SessionExpirationAlertComponent_Template(rf, ctx) { }, encapsulation: 2, changeDetection: 0 });
SessionExpirationAlertComponent.ctorParameters = () => [
    { type: SessionTimerService },
    { type: NgbModal },
    { type: SessionInteruptService }
];
__decorate([
    Input(),
    __metadata("design:type", Object)
], SessionExpirationAlertComponent.prototype, "startTimer", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], SessionExpirationAlertComponent.prototype, "alertAt", void 0);
SessionExpirationAlertComponent = __decorate([ __metadata("design:paramtypes", [SessionTimerService,
        NgbModal,
        SessionInteruptService])
], SessionExpirationAlertComponent);

var SessionExpirationAlert_1;
let SessionExpirationAlert = SessionExpirationAlert_1 = class SessionExpirationAlert {
    static forRoot(config = {
        totalMinutes: 20
    }) {
        return {
            ngModule: SessionExpirationAlert_1,
            providers: [
                {
                    provide: ConfigToken,
                    useValue: config
                }
            ]
        };
    }
};
SessionExpirationAlert.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: SessionExpirationAlert });
SessionExpirationAlert.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function SessionExpirationAlert_Factory(t) { return new (t || SessionExpirationAlert)(); }, providers: [
        SessionTimerService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: SessionTimerHttpInterceptor,
            multi: true
        },
        SessionInteruptService
    ], imports: [[CommonModule, NgbModule]] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SessionTimerService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [ConfigToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SessionTimerHttpInterceptor, [{
        type: Injectable
    }], function () { return [{ type: SessionTimerService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SessionInteruptService, [{
        type: Injectable
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SessionExpirationAlertModalComponent, [{
        type: Component,
        args: [{
                template: "<div class=\"modal-header bg-warning\">\r\n  <h4 class=\"modal-title\">Session is about to expire</h4>\r\n</div>\r\n<div class=\"modal-body\">\r\n  <div class=\"my-4\" style=\"font-size: 1.25rem;\">\r\n    <p>\r\n      Your session will expire in\r\n      {{ sessionTimer.remainSeconds$ | async }} seconds.\r\n    </p>\r\n  </div>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button type=\"button\" class=\"btn btn-secondary\" (click)=\"logout()\">\r\n    Logout\r\n  </button>\r\n  <button\r\n    type=\"button\"\r\n    ngbAutofocus\r\n    class=\"btn btn-primary\"\r\n    (click)=\"continue()\"\r\n  >\r\n    Continue Session\r\n  </button>\r\n</div>\r\n"
            }]
    }], function () { return [{ type: ɵngcc1.NgbActiveModal }, { type: SessionInteruptService }, { type: SessionTimerService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SessionExpirationAlertComponent, [{
        type: Component,
        args: [{
                selector: 'session-expiration-alert',
                template: '',
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: SessionTimerService }, { type: ɵngcc1.NgbModal }, { type: SessionInteruptService }]; }, { startTimer: [{
            type: Input
        }], alertAt: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SessionExpirationAlert, { declarations: function () { return [SessionExpirationAlertComponent,
        SessionExpirationAlertModalComponent]; }, imports: function () { return [CommonModule, NgbModule]; }, exports: function () { return [SessionExpirationAlertComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SessionExpirationAlert, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, NgbModule],
                declarations: [
                    SessionExpirationAlertComponent,
                    SessionExpirationAlertModalComponent
                ],
                providers: [
                    SessionTimerService,
                    {
                        provide: HTTP_INTERCEPTORS,
                        useClass: SessionTimerHttpInterceptor,
                        multi: true
                    },
                    SessionInteruptService
                ],
                exports: [SessionExpirationAlertComponent],
                entryComponents: [SessionExpirationAlertModalComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of session-expiration-alert
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ConfigToken, SessionExpirationAlert, SessionExpirationAlertComponent, SessionInteruptService, SessionTimerHttpInterceptor, SessionTimerService, SessionExpirationAlertModalComponent as ɵa };

//# sourceMappingURL=session-expiration-alert.js.map